import { toast } from "react-toastify";
import ItemModel from "../../../components/items/model/item";
import {
    ADD_ITEM_FAILIRE,
    ADD_ITEM_REQUEST,
    ADD_ITEM_SUCCESS,
    DELETE_ITEM_SUCCESS, FILTER_NO_BARCODE, FILTER_NO_CATEGORY,
    FILTER_NO_COVER, FILTER_NO_INTERNAL_ID,
    SEARCH_ITEM_FAILIRE,
    SEARCH_ITEM_REQUEST,
    SEARCH_ITEM_SUCCESS
} from "../../ActionType/ActionType";


const initilaState ={
    item : new ItemModel(),
    items : [],
    isLoading : false,
}

export const ItemReducer=(state=initilaState, action)=>{
    switch (action.type) {
        case SEARCH_ITEM_REQUEST:
            return{
                ...state,
                isLoading : true,
                items: [],
            }
        case FILTER_NO_COVER:
            return{
                ...state,
                isLoading : true,
                items: [],
            }
        case FILTER_NO_BARCODE:
            return{
                ...state,
                isLoading : true,
                items: [],
            }
        case FILTER_NO_CATEGORY:
            return{
                ...state,
                isLoading : true,
                items: [],
            }
        case FILTER_NO_INTERNAL_ID:
            return{
                ...state,
                isLoading : true,
                items: [],
            }
        case SEARCH_ITEM_SUCCESS:
            return{
                ...state,
                isLoading : false,
                items: action.payload,
            }
        case SEARCH_ITEM_FAILIRE:
            toast.info(action.error)
            return{
                ...state,
                isLoading : false,
                items: [],
            }
        case ADD_ITEM_REQUEST:
            return{...state, isLoading :true}
        case ADD_ITEM_SUCCESS:
            toast.info("Enregistré avec succès")

            return{...state, isLoading :false}
        case ADD_ITEM_FAILIRE:
            toast.error("Opération échouée")
            return{...state, isLoading :false}
        case DELETE_ITEM_SUCCESS:
            toast.warn("Supprimé avec succès")
            var rest = state.items.filter(e=>e.id !== action.payload);
            return{...state, items : rest, isLoading : false}
        default:
            return{...state, isLoading :false}
    }
}
